import React from "react";

const LeftServiceSubCardSection1 = (props) => {
  return (
    <li className="flex  cursor-pointer items-center justify-evenly hover:text-blue-700">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="arrow w-6  h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5"
        />
      </svg>
      <div className="">{props.quote}</div>
    </li>
  );
};

export default LeftServiceSubCardSection1;
